import { styled } from '@mui/styles';
import { Paper } from '@mui/material';

export const StyledSectionPaper = styled(Paper)(({ theme }) => ({
  padding: 24,
  minHeight: 240,
  backgroundColor: theme.vars.palette.bigid?.white,
  boxShadow: theme.vars.tokens?.bigid?.shadow10,
  marginBottom: 40,

  [theme.breakpoints.down('sm')]: {
    padding: 32,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    marginBottom: 0,
  },
}));
